import { Box, Button, ButtonProps, CircularProgress } from "@mui/material";
import { useMemo } from "react";

type ILoadingButtonProps = {
  isLoading?: boolean;
  label: string;
} & ButtonProps;

export const LoadingButton = ({ isLoading, label, ...otherProps }: ILoadingButtonProps) => {

  const disabled: boolean = useMemo(() => Boolean(otherProps.disabled || isLoading), [otherProps, isLoading])

  return (
    <Button disabled={disabled} sx={{ backgroundColor: disabled ? "grey" : undefined }} {...otherProps}>
      {isLoading ? <CircularProgress size={"20px"}/> : label}
    </Button>
  );

};